import { render, staticRenderFns } from "./UserProfileCurrent.vue?vue&type=template&id=60d33d9a&scoped=true&"
import script from "./UserProfileCurrent.vue?vue&type=script&lang=js&"
export * from "./UserProfileCurrent.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileCurrent.vue?vue&type=style&index=0&id=60d33d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d33d9a",
  null
  
)

export default component.exports